<div class="w-full flex items-center px-3">
    <div class="flex flex-row w-full gap-x-2 items-center">

        @if (showBlueQuery) {
        <div class="grid grid-cols-1" [formGroup]="filtersForm">
            <input formControlName="searchTerm" id="email" type="email" name="email" placeholder="Search..." (keyup.enter)="filterSearch()"
                class="col-start-1 row-start-1 block w-full rounded-md bg-white/5 py-1.5 pr-3 pl-10 text-base text-white outline-1 -outline-offset-1 outline-white/10 placeholder:text-gray-500 focus:outline-2 focus:-outline-offset-2 focus:outline-primary sm:pl-9 sm:text-sm/6" />
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="pointer-events-none col-start-1 row-start-1 ml-3 size-5 self-center text-gray-500 sm:size-4">
                <path d="m21 21-4.34-4.34" />
                <circle cx="11" cy="11" r="8" />
            </svg>
        </div>
        }

        <span (click)="openFilters()"
            class="text-secondary inline-flex items-center gap-x-1.5 flex-nowrap rounded-md whitespace-nowrap dark:bg-white/20 bg-gray-100 text-xs ring-1 ring-inset ring-white/5 px-2 py-1 cursor-pointer">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-3">
                <path
                    d="M10 20a1 1 0 0 0 .553.895l2 1A1 1 0 0 0 14 21v-7a2 2 0 0 1 .517-1.341L21.74 4.67A1 1 0 0 0 21 3H3a1 1 0 0 0-.742 1.67l7.225 7.989A2 2 0 0 1 10 14z" />
            </svg>
            Filters
        </span>

        <!-- <div class="h-6 border-l border-zinc-300 dark:border-white/10"> </div> -->



        <div (click)="openFilters()"
            class="flex-1 flex flex-row items-center justify-start overflow-x-auto scrollbar-transparent border border-zinc-300 dark:border-white/10 rounded-md p-2">
            <div class="flex flex-row items-center justify-start gap-x-2">
                @for (filter of selectedFilters; track $index) {
                <span
                    class="inline-flex items-center rounded-md px-2 py-1 text-xs font-medium ring-1 ring-inset bg-primary/10 dark:bg-primary/15 text-accent ring-primary/40 whitespace-nowrap flex-shrink-0">
                    {{ filter.value }}
                </span>
                }
            </div>
        </div>
    </div>
</div>


<!-- Filters Overlay -->
@if (magicSearchService.filtersOpen()) {
<div class="fixed inset-0 z-50 flex items-start justify-center pt-12 sm:pt-20" (click)="closeFilters()">
    <!-- Backdrop with blur -->
    <div class="fixed inset-0 bg-black/40 backdrop-blur-sm"></div>

    <!-- Filters Modal -->
    <div class="relative w-full max-w-3xl mx-4 bg-white dark:bg-zinc-700 rounded-lg shadow-2xl"
        (click)="$event.stopPropagation()">

        <div
            class="rounded-md bg-blue-50 dark:bg-blue-900/20 p-4 outline outline-blue-500/15 flex items-center justify-between m-2">
            <div class="flex">
                <div class="shrink-0">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="size-5 text-blue-600 dark:text-blue-400">
                        <path
                            d="M13.354 3H3a1 1 0 0 0-.742 1.67l7.225 7.989A2 2 0 0 1 10 14v6a1 1 0 0 0 .553.895l2 1A1 1 0 0 0 14 21v-7a2 2 0 0 1 .517-1.341l1.218-1.348" />
                        <path d="M16 6h6" />
                        <path d="M19 3v6" />
                    </svg>
                </div>
                <div class="ml-3">
                    <h3 class="text-sm font-medium text-blue-900 dark:text-blue-200">Filters</h3>
                    <div class="mt-1 text-sm text-secondary">
                        <p>Find creators using standard filters to narrow your search
                        </p>
                    </div>
                </div>
            </div>

        </div>

        <div class="w-full py-5 h-96 overflow-hidden">

            @switch (selectedTab()) {
            @case ('profile') {
            <div class="h-full w-full flex flex-col overflow-y-auto px-4">
                <div>
                    <div class="space-y-6">
                        <div class="">
                            <h2 class="text-sm font-semibold text-primary">Profile Filters</h2>
                            <div class="mt-2 grid grid-cols-1 gap-x-6 gap-y-6 sm:grid-cols-6">
                                @if (magicSearchService.fancyActiveFilters) {

                                <!-- Search Term -->
                                <div class="sm:col-span-6" [formGroup]="filtersForm">
                                    <label for="first-name" class="block text-sm/6 font-medium text-primary">Search
                                        Term</label>
                                    <div class="mt-2">
                                        <input #searchTermInput formControlName="searchTerm" id="first-name" type="text"
                                            autocomplete="given-name" class="input-primary text-primary" />
                                    </div>
                                    <p class="mt-1 text-xs leading-6 text-secondary">First name, last name, email
                                        address or handle.</p>
                                </div>
                                <!-- Search Term - END -->

                                <!-- Age Range -->
                                <div class="sm:col-span-6">
                                    <label for="first-name" class="block text-sm/6 font-medium text-primary">Age
                                        Range</label>
                                    <div class="flex flex-row items-center justify-between w-full gap-x-6">
                                        <div class="flex-0 input-primary text-primary">
                                            {{ ageRangeDefault.minValue }}</div>
                                        <mat-slider class="my-material-slider-theme flex-1 mx-4"
                                            [disabled]="ageRangeDefault.disabled" [max]="ageRangeDefault.max"
                                            [min]="ageRangeDefault.min" [step]="ageRangeDefault.step"
                                            [discrete]="ageRangeDefault.thumbLabel"
                                            [showTickMarks]="ageRangeDefault.showTicks">
                                            <input [(ngModel)]="ageRangeDefault.minValue"
                                                (ngModelChange)="onAgeRangeChange($event, 'min')" matSliderStartThumb>
                                            <input [(ngModel)]="ageRangeDefault.maxValue"
                                                (ngModelChange)="onAgeRangeChange($event, 'max')" matSliderEndThumb>
                                        </mat-slider>
                                        <div class="flex-0 input-primary text-primary">
                                            {{ ageRangeDefault.maxValue }}</div>
                                    </div>
                                </div>
                                <!-- Age Range - END -->

                                <!-- SELECT Gender -->
                                <div class="sm:col-span-6">
                                    <label for="first-name" class="block text-sm/6 font-medium text-primary">Creator
                                        Gender</label>
                                    <ul role="list" class="mt-3 grid grid-cols-1 gap-5 sm:grid-cols-3 sm:gap-6">
                                        @for (gender of magicSearchService.fancyActiveFilters.genderOptions; track
                                        gender.id) {
                                        <div class="col-span-1">
                                            <button type="button"
                                                (click)="onSelectedSingleOptionsChange(gender, 'gender')"
                                                class="h-10 w-full inline-flex justify-center items-center gap-x-2 rounded-md px-3 py-1.5 text-sm font-semibold focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary cursor-pointer"
                                                [class]="formControl['gender'].value?.id === gender.id ? 'bg-primary text-white hover:bg-primary/85' : 'bg-zinc-300 dark:bg-zinc-700 text-zinc-900 dark:text-zinc-100 hover:bg-primary/85 outline outline-1 -outline-offset-1 outline-zinc-300 dark:outline-white/10'">
                                                {{ gender.name }}
                                            </button>
                                        </div>
                                        }
                                    </ul>
                                </div>
                                <!-- SELECT Gender - END-->
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            }
            @case ('location') {
            <div class="h-full w-full flex flex-col overflow-y-auto px-4">
                <form>
                    <div class="space-y-6">
                        <div class="" [formGroup]="filtersForm">
                            <h2 class="text-sm font-semibold text-primary">Location Filters</h2>

                            <div class="mt-2 grid grid-cols-1 gap-x-6 gap-y-6 sm:grid-cols-6">
                                <!-- Hometown -->
                                <div class="sm:col-span-6">
                                    <label for="first-name"
                                        class="block text-sm/6 font-medium text-primary">Hometown</label>
                                    <div class="mt-1">
                                        <input placeholder="Search Hometown..." formControlName="homeTownSearchTerm"
                                            #searchField id="brief-title" type="text"
                                            class="input-primary text-primary" />

                                    </div>
                                </div>
                                <!-- Hometown - END -->

                                <!-- Country -->
                                <div class="sm:col-span-6">
                                    <label for="first-name" class="block text-sm/6 font-medium text-primary">Creator
                                        Country</label>
                                    <ul role="list" class="mt-3 grid grid-cols-1 gap-5 sm:grid-cols-3 sm:gap-6">
                                        @for (country of magicSearchService.fancyActiveFilters.countryOptions; track
                                        country.id) {
                                        <div class="col-span-1">
                                            <button type="button"
                                                (click)="onSelectedSingleOptionsChange(country, 'country')"
                                                class="h-10 w-full inline-flex justify-center items-center gap-x-2 rounded-md px-3 py-1.5 text-sm font-semibold focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary cursor-pointer"
                                                [class]="formControl['country'].value?.id === country.id ? 'bg-primary text-white hover:bg-primary/85' : 'bg-zinc-300 dark:bg-zinc-700 text-zinc-900 dark:text-zinc-100 hover:bg-primary/85 outline outline-1 -outline-offset-1 outline-zinc-300 dark:outline-white/10'">
                                                {{ country.name }}
                                            </button>
                                        </div>
                                        }
                                    </ul>
                                </div>
                                <!-- Country - END -->
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            }
            @case ('followers') {
            <div class="h-full w-full flex flex-col overflow-y-auto px-4">
                <form>
                    <div class="space-y-6">
                        <div class="" [formGroup]="filtersForm">
                            <h2 class="text-sm font-semibold text-primary">Followers Filters</h2>

                            <div class="mt-2 grid grid-cols-1 gap-x-6 gap-y-6 sm:grid-cols-6">

                            </div>
                        </div>
                    </div>
                </form>
            </div>
            }
            @case ('interests') {
            <div class="h-full w-full flex flex-col overflow-y-auto px-4">
                <form>
                    <div class="space-y-6">
                        <div class="" [formGroup]="filtersForm">
                            <h2 class="text-sm font-semibold text-primary">Niche Filters</h2>

                            <div class="mt-2 grid grid-cols-1 gap-x-6 gap-y-6 sm:grid-cols-6">
                                <!-- Interests -->
                                <div class="sm:col-span-6">
                                    <label for="first-name" class="block text-sm/6 font-medium text-primary">Creator
                                        Niches
                                        <p class="text-xs text-secondary">These are niches & interests set by creators.
                                            Filter by one or more niches.</p>
                                    </label>
                                    <div class="mt-2 flex flex-wrap gap-2">
                                        @for (interest of magicSearchService.fancyActiveFilters.interestsOptions; track
                                        interest.id) {
                                        <button type="button"
                                            (click)="uiOneOfMultipleSelectionChange(interest, 'interests')"
                                            class="inline-flex gap-x-1.5 rounded-full px-2.5 py-1.5 text-xs shadow-sm ring-1 ring-inset ring-gray-300 dark:ring-gray-600 hover:bg-gray-50 dark:hover:bg-zinc-800 cursor-pointer"
                                            [class]="formControl['interests'].value?.includes(interest) ? 'ring-primary/40 dark:ring-primary text-accent bg-primary/10 dark:bg-primary/15' : 'text-secondary ring-gray-300 dark:ring-gray-600 bg-transparent'">
                                            {{ interest.icon!.name }} {{ interest.name }}
                                        </button>
                                        }

                                    </div>
                                </div>
                                <!-- Interests - END -->


                            </div>
                        </div>
                    </div>
                </form>
            </div>
            }
            @case ('sort') {
                
            }
            }
        </div>

        <div class="w-full py-2 flex items-center justify-between px-4">

            <nav aria-label="Tabs" class="flex space-x-4">
                <a (click)="setFiltersTab('profile')" class="rounded-md px-3 py-2 text-sm font-medium cursor-pointer"
                    [class]="getTabClass('profile')">Profile</a>
                <a (click)="setFiltersTab('location')" class="rounded-md px-3 py-2 text-sm font-medium cursor-pointer"
                    [class]="getTabClass('location')">Location</a>
                <a (click)="setFiltersTab('followers')" class="rounded-md px-3 py-2 text-sm font-medium cursor-pointer"
                    [class]="getTabClass('followers')">Followers</a>
                <a (click)="setFiltersTab('interests')" class="rounded-md px-3 py-2 text-sm font-medium cursor-pointer"
                    [class]="getTabClass('interests')">Niches</a>
                <a (click)="setFiltersTab('sort')" class="rounded-md px-3 py-2 text-sm font-medium cursor-pointer"
                    [class]="getTabClass('sort')">Sort</a>
            </nav>

            <div class="flex flex-row items-center gap-x-2">
                <button (click)="resetFilters()" type="button" class="secondary-button-small text-secondary">Reset
                    Filters</button>
                <button (click)="filterSearch()" type="button" class="primary-go-button">Apply</button>

            </div>
        </div>
    </div>
</div>
}